import { createRequestTypes, action } from "../../utils/reducer";

export const CREATE_ACCOUNT = createRequestTypes("CREATE_ACCOUNT");
export const createAccount = {
  request: (data) => action(CREATE_ACCOUNT.REQUEST, data),
  success: (data) => action(CREATE_ACCOUNT.SUCCESS, data),
  failure: (error) => action(CREATE_ACCOUNT.FAILURE, error),
};
export const RESET_CREATE_ACCOUNT = createRequestTypes("RESET_CREATE_ACCOUNT");
export const resetCreateAccount = {
  success: () => action(RESET_CREATE_ACCOUNT.SUCCESS),

};


export const SEND_LOGIN_OTP = createRequestTypes("SEND_LOGIN_OTP");
export const sendLoginOTP = {
  request: (data) => action(SEND_LOGIN_OTP.REQUEST, data),
  success: (data) => action(SEND_LOGIN_OTP.SUCCESS, data),
  failure: (error) => action(SEND_LOGIN_OTP.FAILURE, error),
};
export const RESET_SEND_LOGIN_OTP = createRequestTypes("RESET_SEND_LOGIN_OTP");
export const resetSendLoginOTP = {
  success: () => action(RESET_SEND_LOGIN_OTP.SUCCESS)
};

export const VERIFY_ACCOUNT = createRequestTypes("VERIFY_ACCOUNT");
export const verifyAccount = {
  request: (data) => action(VERIFY_ACCOUNT.REQUEST, data),
  success: (data) => action(VERIFY_ACCOUNT.SUCCESS, data),
  failure: (error) => action(VERIFY_ACCOUNT.FAILURE, error),
};
export const RESET_VERIFY_ACCOUNT = createRequestTypes("RESET_VERIFY_ACCOUNT");
export const resetVerifyAccount = {
  success: () => action(RESET_VERIFY_ACCOUNT.SUCCESS),

};

export const VERIFY_LOGIN_OTP = createRequestTypes("VERIFY_LOGIN_OTP");
export const verifyLoginOTP = {
  request: (data) => action(VERIFY_LOGIN_OTP.REQUEST, data),
  success: (data) => action(VERIFY_LOGIN_OTP.SUCCESS, data),
  failure: (error) => action(VERIFY_LOGIN_OTP.FAILURE, error),
};
export const RESET_VERIFY_LOGIN_OTP = createRequestTypes("RESET_VERIFY_LOGIN_OTP");
export const resetVerifyLoginOTP = {
  success: () => action(RESET_VERIFY_LOGIN_OTP.SUCCESS),

};

export const GET_ACCESS_TOKEN = createRequestTypes("GET_ACCESS_TOKEN");
export const getAccessToekn = {
  request: (data) => action(GET_ACCESS_TOKEN.REQUEST, data),
  success: (data) => action(GET_ACCESS_TOKEN.SUCCESS, data),
  failure: (error) => action(GET_ACCESS_TOKEN.FAILURE, error),
};